export enum LoadingStatus {
    LOADING,
    RELOADING,
    FAILED,
    LOADED
}



// WEBPACK FOOTER //
// ./src/app/common-types/loading-status.ts